


























































































import Vue from 'vue'
import { Store } from 'vuex'
import style from './style.module.scss'

import infoBlock from './info-block/info-block.vue'
import infoBlockRow from './info-block-row/info-block-row.vue'

import { UserInfo, Certificate, SignDocs, SignObject, Signature } from '@/data/crypto-sign-info-types/types'
import { ResponseError } from '@/data/common/types'

export default Vue.extend({
name: 'crypto-sign-info',
  components: {
    infoBlock,
    infoBlockRow
  },
  data() {
    return {
      style: style,
      eventBus: window.VUE_EVENT_BUS_CRYPTO_SIGN_INFO,
      window: window
    }
  },
  methods: {
    fileDownLoad(event: MouseEvent, content: string) {
      
      //поддержка IE
      if (typeof window.navigator.msSaveBlob === 'function') {
        event.preventDefault();
        const blob = new Blob([content], { type: 'text/plain' })
        window.navigator.msSaveOrOpenBlob(blob, `signature-${content.substring(0,8)}.txt`);
      }
    },
    buidlUrlForFile(content: string): string {
      return window.URL.createObjectURL(new Blob([content], { type: 'text/plain' }))
    }
  },
  computed: {
    dateTime(): string {
      return `${new Date().toLocaleDateString('ru')} ${new Date().toLocaleTimeString('ru', {hour: '2-digit', minute:'2-digit'})}`
    },
    userInfo(): UserInfo {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.UserInfo;
    },
    certificate(): Certificate {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.Certificate;
    },
    signObject(): SignObject  {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.SignObject;
    },
    signDocs(): SignDocs {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.SignDocs;
    },
    signature(): Signature {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.Signature;
    },
    error(): ResponseError | null | undefined {
      return (this.$store as Store<RootStateSignInfo>).state.signInfo.Error;
    }
  }
})
